import styled from 'styled-components';

import { BasicSubtitle, SmallParagraph } from '@genially/design-system';
import { StatisticsIcon } from '@genially/icons';

import { PANEL_SURFACE } from '../common/panelColors';

export const Wrapper = styled.div(({ theme: { color, size } }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: size.units(1.5),
  padding: size.units(4),
  borderRadius: size.units(1),
  backgroundColor: PANEL_SURFACE,
  textAlign: 'center',
}));

export const StyledStatisticsIcon = styled(StatisticsIcon)(
  ({ theme: { color, size } }) => ({
    width: size.units(7),
    height: size.units(7),
    color: color.content.reversed.default(0.3),
  }),
);

export const Title = styled(BasicSubtitle)(({ theme: { color } }) => ({
  color: color.content.reversed.default(),
}));

export const Description = styled(SmallParagraph)(({ theme: { color } }) => ({
  color: color.content.primary.disabled(),
}));
